import { Component, Input } from '@angular/core';
import { CxSchedularService } from '../cx-schedular.service';

@Component({
  selector: 'cx-schedular-list',
  templateUrl: './cx-schedular-list.component.html',
  styleUrl: './cx-schedular-list.component.scss'
})
export class CxSchedularListComponent {
  @Input() module = '';

  constructor(public cxSchedularService: CxSchedularService) { }

  onRead ($event: MouseEvent, schedual: any) {
    $event.preventDefault();
    $event.stopPropagation();

    this.cxSchedularService.edit_id = schedual.id;
    this.cxSchedularService.editMode = false;

    this.cxSchedularService.changeScreen(this.cxSchedularService.SCREENS.TWO)
  }

  onEdit ($event: MouseEvent, schedual: any) {
    $event.preventDefault();
    $event.stopPropagation();

    this.cxSchedularService.edit_id = schedual.id;
    this.cxSchedularService.editMode = true;
    this.cxSchedularService.changeScreen(this.cxSchedularService.SCREENS.TWO)
  }

  onDelete ($event: MouseEvent, schedual: any) {
    $event.preventDefault();
    $event.stopPropagation();

    this.cxSchedularService.delete(schedual.id).subscribe((x) => {
      this.cxSchedularService.getData();
    })
  }
}
